import OverlayTips from "../../OverlayTips";

function PastLeavesPageOverlayTipsManager()
{
    PageOverlayTipsManager.call(this);
    this._refreshDynamicTipsDeferred = true;
}

PastLeavesPageOverlayTipsManager.prototype = _.create(PageOverlayTipsManager.prototype, {

    addBaseTips: function()
    {
        PageOverlayTipsManager.prototype.addBaseTips.apply(this);

        this.add($("#pastLeaveExportSelector"), {
            messageKey: "actiplans.reports.tips.export",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: -40,
            offsetY: 15
        });

        this.add($("#leaveTypeFilter"), {
            messageKey: "actiplans.reports.past_leaves_calendar.tips.leave_types_filter",
            direction: OverlayTips.DIRECTION_BOTTOM_RIGHT,
            offsetX: -50,
            offsetY: 15
        });

        this.add($('#leaveTimeHistoryHeaderSelectors').find(".monthRangeSelector .selectorDescription"), {
            messageKey: "actiplans.reports.past_leaves_calendar.tips.date_range",
            direction: OverlayTips.DIRECTION_BOTTOM_RIGHT,
            offsetX: -16,
            offsetY: 11
        });

        this.add($("#sliderButton").find(".sliderImg"), {
            messageKey: "actiplans.reports.past_leaves_calendar.tips.details_button",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: 0,
            offsetY: 0,
            outside: {
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                offsetX: 0,
                offsetY: 0
            }
        });

        this.add($("#leaveTimeTable").find(".period.sortHeader"), {
            messageKey: "actiplans.reports.past_leaves_calendar.tips.sorting",
            direction: OverlayTips.DIRECTION_TOP_RIGHT,
            anchor: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: 50,
            offsetY: 20
        });
        
        
    }
});

export default PastLeavesPageOverlayTipsManager;


// WEBPACK FOOTER //
// ./web/actiplans/js/tips/managers/reports/PastLeavesPageOverlayTipsManager.js